import { render, staticRenderFns } from "./dotline.vue?vue&type=template&id=42e127b0&scoped=true"
import script from "./dotline.vue?vue&type=script&lang=js"
export * from "./dotline.vue?vue&type=script&lang=js"
import style0 from "./dotline.vue?vue&type=style&index=0&id=42e127b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e127b0",
  null
  
)

export default component.exports